/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventLogFilterEntryList } from '../../models/event-log-filter-entry-list';
import { EventLogSearch } from '../../models/event-log-search';
import { EventLogSortFieldName } from '../../models/event-log-sort-field-name';
import { SortDirection } from '../../models/sort-direction';

export interface SearchEventLogStation$Json$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * DATE : the date
 *   * TAG : the tag name
 *   * DESCRIPTION : the tag description
 *   * VALUE : the value
 */
  sortFieldName?: EventLogSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The search text to filter API
 */
  search?: string;
  
    /**
     * Body for search events log
     */
    body?: EventLogSearch
}

export function searchEventLogStation$Json(http: HttpClient, rootUrl: string, params: SearchEventLogStation$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EventLogFilterEntryList>> {
  const rb = new RequestBuilder(rootUrl, searchEventLogStation$Json.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EventLogFilterEntryList>;
    })
  );
}

searchEventLogStation$Json.PATH = '/stations/{uid}/eventslogfilter/search';
